// components/MultiSelect/MultiSelect.jsx
import React from "react";
import Select from "react-select";

const MultiSelect = ({
  items = [], // tableau de strings à mapper
  selectedOptions,
  setSelectedOptions,
  name, // ex: "qualifications" ou "secteurs"
  label, // texte du <label>
  placeholder, // texte du placeholder
}) => {
  const options = items.map((item) => ({ value: item, label: item }));

  return (
    <div className="space-y-2">
      {label && (
        <label htmlFor={name} className="block text-sm font-medium text-black">
          {label}
        </label>
      )}
      <Select
        isMulti
        name={name}
        options={options}
        className="basic-multi-select"
        classNamePrefix="select"
        placeholder={placeholder}
        value={selectedOptions}
        onChange={setSelectedOptions}
      />
    </div>
  );
};

export default MultiSelect;
